<template>
  <el-tooltip placement="left-start" :content="displayTitle" :disabled="!displayTitle" >
    <div @click="onClick" :class="`icon-menu-item ${disabled ? ' disabled' : 'enabled'}`">
      <FAIcon :icon="icon" :color="color" :disabled="disabled" />
      {{ title }}
    </div>
  </el-tooltip>
</template>

<script>
import { Colors } from '@/constants/DoITConstant.js'
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: 'IconMenuItem',
  components: { FAIcon },
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'fas fa-question',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: Colors.BLACK,
    },
  },
  data() {
    return {
      Colors,
    }
  },
  methods: {
    onClick() {
      if (this.disabled) return
      this.$emit('click')
    },
  },
  computed: {
    displayTitle() {
      return this.disabled ? 'Bạn không có quyền thực hiện chức năng này' : null
    },
  },
}
</script>

<style>
.icon-menu-item.disabled {
  cursor: default;
    color: gray;
}
.icon-menu-item.enabled {
  cursor: pointer;
}
</style>
